import { css } from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from './purpurSelectors';

export const teliaFocus = (spacing?: string) => {
    return css`
        &:focus {
            outline: solid ${getPurpurBorder('widthMd')} ${getPurpurColor('blue500')};
            outline-offset: ${spacing || getPurpurSpacing('25')};
            box-shadow: none;
        }
        &:focus:not(:focus-visible) {
            outline: 0;
        }
    `;
};

export const purpurFocus = (spacing?: string) => {
    return css`
        &:focus {
            outline: solid ${getPurpurBorder('widthSm')} ${getPurpurColor('borderInteractiveFocus')};
            outline-offset: ${spacing || getPurpurSpacing('25')};
            box-shadow: none;
        }
        &:focus:not(:focus-visible) {
            outline: 0;
        }
    `;
};

export const defaultLinkStyle = () => {
    return css`
        background-color: transparent;
        color: ${getPurpurColor('functionalBlack')};
        transition:
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            color 0.15s ease-in-out;
        text-decoration: underline;

        &:hover {
            color: ${getPurpurColor('purple500')};
            text-decoration: none;
        }
        &:hover,
        &:focus,
        &:active {
            text-decoration: none;
        }
        &:hover,
        &:active {
            outline: 0;
        }
    `;
};
